module.exports = __webpack_public_path__ + "assets/e8102f39619ea25e0fc8cdf1d8e496fa.png";